import { useFormSelector } from '@elfsight/widget-form-builder/widget';
import { useSettings } from '@wu/widget-core';
import { useFieldsValues } from './use-fields-values';

export const useFieldsScope = () => {
  const { fields } = useSettings();
  const { fields: changedFields } = useFormSelector();
  const fieldsWithData = useFieldsValues(fields, { ...changedFields });
  const scope = Object.fromEntries(
    fieldsWithData.map(({ id, value }) => [id, { value }])
  );

  return scope;
};
